// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type ClearSessionMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ClearSessionMutation = { __typename?: 'Mutation', clearSession?: { __typename?: 'Login', accessToken?: string | null } | null };


export const ClearSessionDocument = gql`
    mutation ClearSession {
  clearSession {
    accessToken
  }
}
    `;
export type ClearSessionMutationFn = Apollo.MutationFunction<ClearSessionMutation, ClearSessionMutationVariables>;
export type ClearSessionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ClearSessionMutation, ClearSessionMutationVariables>, 'mutation'>;

    export const ClearSessionComponent = (props: ClearSessionComponentProps) => (
      <ApolloReactComponents.Mutation<ClearSessionMutation, ClearSessionMutationVariables> mutation={ClearSessionDocument} {...props} />
    );
    

/**
 * __useClearSessionMutation__
 *
 * To run a mutation, you first call `useClearSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearSessionMutation, { data, loading, error }] = useClearSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearSessionMutation(baseOptions?: Apollo.MutationHookOptions<ClearSessionMutation, ClearSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearSessionMutation, ClearSessionMutationVariables>(ClearSessionDocument, options);
      }
export type ClearSessionMutationHookResult = ReturnType<typeof useClearSessionMutation>;
export type ClearSessionMutationResult = Apollo.MutationResult<ClearSessionMutation>;
export type ClearSessionMutationOptions = Apollo.BaseMutationOptions<ClearSessionMutation, ClearSessionMutationVariables>;